<template>
  <div class="animated fadeIn">
    <b-row class="mt-2 mb-2">
      <b-col>
        <h2>บริษัททั้งหมด</h2>
      </b-col>
      <b-col>
        <b-button
          @click="$router.push({ name: 'สร้างบริษัท'})"
          class="float-right"
          variant="primary"
        >สร้างบริษัท</b-button>
      </b-col>
    </b-row>
    <b-card>
      <b-row>
        <b-col lg="6" class="my-1">
          <b-form-group
            label="ค้นหา"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="5" md="6" class="my-1">
          <b-form-group
            label="จำนวนต่อหน้า"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            label-for="perPageSelect"
            class="mb-0"
          >
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <hr class="divider" />
      <b-row class="p-2">
        <b-col sm="12">
          <h5>ค้นหารถเที่ยวกลับ</h5>
        </b-col>
        <b-col sm="12" xl="4">
          <MultiSelectTruckTag label="ชนิดรถ" v-model="truckType" />
        </b-col>
        <b-col sm="12" xl="4">
          <MultiSelectTag label="จาก" v-model="backHaulFrom" :options="serviceAreaOptions" />
        </b-col>
        <b-col sm="12" xl="4">
          <MultiSelectTag label="ไปยัง" v-model="backHaulTo" :options="serviceAreaOptions" />
        </b-col>
        <b-col sm="12">
          <b-button variant="primary" @click="searchBackHual">ค้นหาเที่ยวกลับ</b-button>
          <b-button variant="warning" @click="clearSearchBackHual" class="ml-2">ล้างค่า</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            :items="companies"
            :fields="tableFields"
            striped
            responsive="sm"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            @filtered="onFiltered"
          >
            <template slot="cid" slot-scope="row">{{ row.item.cid }}</template>

            <template slot="type" slot-scope="row">{{ row.item.type }}</template>

            <template slot="name" slot-scope="row">{{ row.item.name }}</template>

            <template
              slot="status"
              slot-scope="row"
            >{{ row.item.shipperStatus === 1 ? 'ยืนยัน' : '' }}</template>

            <template slot="businessType" slot-scope="row">{{ row.item.businessType }}</template>

            <template
              slot="lastActivate"
              slot-scope="row"
            >{{ row.item.lastActivate ? $moment(row.item.lastActivate).format('LLL') : '' }}</template>

            <template slot="actions" slot-scope="row">
              <b-button
                variant="primary"
                size="sm"
                :to="{name: 'อัพเดทบริษัท', params: {companyId:row.item._id}}"
                class="mr-1"
              >จัดการ</b-button>
              <!-- <b-button
                variant="warning"
                size="sm"
                :to="{name: 'อัพเดทบริษัท-shipper', params: {companyId:row.item._id}}"
                class="mr-1"
              >สำหรับ Shipper</b-button>-->
              <b-button
                variant="danger"
                size="sm"
                @click="deleteCompany(row.item._id)"
                class="mr-1"
              >ลบ</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            size="md"
            :total-rows="totalCompany"
            v-model="currentPage"
            :per-page="perPage"
            first-text="หน้าแรก"
            prev-text="หน้าที่แล้ว"
            next-text="หน้าถัดไป"
            last-text="หน้าสุดท้าย"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <ModalLoading />
  </div>
</template>

<script>
import ModalLoading from '../../../components/ModalLoading'

import MultiSelectTag from '../../../components/MultiSelectTag'
import MultiSelectTruckTag from '../../../components/MultiSelectTruckTag'

import Company from '../../../services/http/Company'

export default {
  components: {
    ModalLoading,
    MultiSelectTag,
    MultiSelectTruckTag
  },
  data () {
    return {
      tableFields: [
        { key: 'cid', label: 'รหัสบริษัท', class: 'text-center' },
        { key: 'type', label: 'ประเภทบริษัท', class: 'text-center', sortable: true },
        { key: 'name', label: 'ชื่อบริษัท', class: 'text-center', sortable: true },
        { key: 'status', label: 'สถานะ', class: 'text-center' },
        { key: 'businessType', label: 'ประเภทธุรกิจ', class: 'text-center', sortable: true },
        { key: 'lastActivate', label: 'เข้าครั้งสุดท้ายเมื่อ', class: 'text-center', sortable: true },
        { key: 'actions', label: 'จัดการ' }
      ],
      companiesOri: [],
      companies: [],
      totalCompany: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50, 100],
      filter: null,
      filterOn: [],
      truckType: [],
      backHaulFrom: [],
      backHaulTo: [],
      serviceAreaOptions: [
        { value: 'ภาคเหนือ' },
        { value: 'ภาคตะวันออกเฉียงเหนือ' },
        { value: 'ภาคกลาง' },
        { value: 'ภาคตะวันออก' },
        { value: 'ภาคตะวันตก' },
        { value: 'ภาคใต้' }
      ]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      Window.Event.$emit('showModalLoading')
      try {
        var company = new Company()
        var companies = await company.getCompanyProfileAll()
        this.companiesOri = companies.data
        this.companies = companies.data
        this.totalCompany = this.companies.length
      } catch (error) {
        console.log(error)
      }
      Window.Event.$emit('closeModalLoading')
    },
    openCompanyEdit (company) {
      console.log('create')
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalCompany = filteredItems.length
      this.currentPage = 1
    },
    async deleteCompany (companyId) {
      if (!confirm('ยืนยันลบ ผู้ใช้งานในบริษัทนี้จะถูกลบทั้งหมด')) {
        return
      }
      let data = {
        companyId: companyId
      }
      let company = new Company()
      try {
        let deleted = await company.deleteCompany(data)
        if (deleted.code === 1) {
          alert('ลบแล้ว')
          this.companies = this.companies.filter(company => company._id !== companyId)
          this.totalCompany = this.companies.length
        } else {
          alert('พบข้อผิดพลาด')
        }
      } catch (error) {
        console.log(error)
      }
    },
    searchBackHual () {
      this.companies = this.companiesOri

      // do filter truckType
      if (this.truckType.length > 0) {
        let backHualTruck = this.truckType.map(x => x.typeName)
        this.companies = this.companies.filter((x) => {
          if (x.backhaulRequest) {
            for (let i = 0; i < backHualTruck.length; i++) {
              for (let j = 0; j < x.backhaulRequest.length; j++) {
                let tested = x.backhaulRequest[j].truckType.includes(backHualTruck[i])
                // console.log(x.name, x.backhaulRequest[j].truckType, backHualTruck[i], tested)
                if (tested) {
                  return true
                }
              }
            }
          }
          return false
        })
        // console.log(backHualTruck)
      }

      // do search from
      if (this.backHaulFrom.length > 0) {
        let backHualFrom = this.backHaulFrom.map(x => x.value)
        this.companies = this.companies.filter((x) => {
          if (x.backhaulRequest) {
            for (let i = 0; i < backHualFrom.length; i++) {
              for (let j = 0; j < x.backhaulRequest.length; j++) {
                if (x.backhaulRequest[j].from === backHualFrom[i]) {
                  return true
                }
              }
            }
          }
          return false
        })
      }

      // do search to
      if (this.backHaulTo.length > 0) {
        let backHaulTo = this.backHaulTo.map(x => x.value)
        this.companies = this.companies.filter((x) => {
          if (x.backhaulRequest) {
            for (let i = 0; i < backHaulTo.length; i++) {
              for (let j = 0; j < x.backhaulRequest.length; j++) {
                if (x.backhaulRequest[j].to === backHaulTo[i]) {
                  return true
                }
              }
            }
          }
          return false
        })
      }

      this.totalCompany = this.companies.length
    },
    clearSearchBackHual () {
      this.companies = this.companiesOri
      this.totalCompany = this.companies.length
    }
  }
}
</script>
